import React, {useEffect, useState} from 'react';
import {
  Grid,
    Paper, Typography, Box, Stack, FormHelperText, TextField, Autocomplete,
    FormControl, InputLabel, MenuItem, Select,
  Button
} from '@mui/material';


import { DateTimePicker  as DesktopDateTimePicker } from '@mui/x-date-pickers'
import { DesktopDatePicker , DatePicker} from '@mui/x-date-pickers';
//import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import { format, set } from 'date-fns';


import {useNavigate} from 'react-router-dom' 

import { useDispatch, useSelector } from 'react-redux';
import {useParams} from "react-router-dom"

import {
  selectRequestById, 
   allowRequest} from '../../store/requestSlice'

import {  
    selectAllFloors,
  }  from '../../store/floorSlice'
import {usePlayContext} from '../../utils/PlayContext';

import {getTimeStr, getDateISOString, 
  getDateTime, getValidEndTimes, allStartTimes, allEndTimes,
   getAllDays, getWeekDayName} from '../../utils/timeConfig'


const PendingRequestApprovePage = () => {

  const {
    op, setOp,
     setStatus,   setAppTitle,
    errorMessage, setErrorMessage, setErrorTitle,
  }=usePlayContext()

  const {id} = useParams();
  const it = useSelector(selectRequestById(id))
  
  const [subTtitle, setSubTtitle]=useState('')
  

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const allFloors = useSelector(selectAllFloors)

  const [floor, setFloor]=useState(allFloors && allFloors.length>0 ? allFloors[0].name :'' 
  )
  const [floorError, setFloorError]=useState('')
  
  const [startDate, setStartDate] = useState(new Date())
  const [startDateError, setStartDateError] = useState('')
  const [startTime, setStartTime] =useState('')
  const [startTimeError, setStartTimeError] = useState('')
 const [endDate, setEndDate] =   useState( new Date());
  const [endDateError, setEndDateError] = useState('')

  const [endTime, setEndTime] = useState('')
  const [endTimeError, setEndTimeError] = useState('')



  const [hostRemarks, setHostRemarks]=useState('')

  const doApproveRequest= async()=>{
      
      const rightNow = Date.now()
      let errNo=0

      if (!Boolean(floor))
      {
          errNo++
          setFloorError('Flor is required')
      }
      else setFloorError('')

      if (errNo>0) return
      
        setStartDateError('')
        setStartTimeError('')
        setEndDateError('')
        setEndTimeError('')

        let date1 = null;
        let date2 = null;
        let time1 = null;
        let time2 = null;
        const today_date = format(new Date(),'yyyy-MM-dd') 
        const today_time = format(new Date(),'HH:mm') 

     
        if (!Boolean(startDate))
        {
            errNo++;
            setStartDateError("Start date is required")
        }      
        else if ( !Boolean(date1=getDateISOString(startDate)))
        {
          errNo++;
          setStartDateError("Start date is invalid") 
        }
        else  if (date1<today_date)
        {
          errNo++
          setStartDateError("Start date cannot be earlier than current date")
        }


        if (!Boolean(endDate))
        {
            errNo++;
            setEndDateError("End date is required")
        }      
        else if ( !Boolean(date2=getDateISOString(endDate)))
        {
          errNo++;
          setEndDateError("End date is invalid") 
        }
        else if (date2<date1 || date2<today_date)
        {
          errNo++
          setEndDateError("End Date cannot be earlier than start date")

        }
        //alert(date2+'--'+today_date)
      
        if (!Boolean(startTime))
        {
          errNo++;
          setStartTimeError("Start time is required")
        }
        else if (!Boolean(time1=getTimeStr(startTime)))
        {
          errNo++;
          setStartTimeError("Start time is invalid")
        }
       

        if (!Boolean(endTime))
        {
          errNo++;
          setEndTimeError("End time is required")
        }
        else if (!Boolean(time2=getTimeStr(endTime)))
        {
          errNo++;
          setEndTimeError("End time is invalid")
        }
      


        if (errNo>0) return

        let tmp1 = Date.parse(getDateTime(startDate, startTime));
        let tmp2 = Date.parse(getDateTime(endDate, endTime));
      
        if (tmp1<Date.now())
        {
          errNo++
          setStartTimeError("Start Time cannot be earlier than current time")
          
        }
        if (tmp2<=tmp1)
        {
          errNo++
          setEndTimeError("End Time cannot be earlier than start time")
          
        }
      if (errNo>0) return
      
      
      setStatus('processing')
    
      let action={
        id,
        status:'APPROVED',
        floor,

        
      }
      action.startInviteTm=getDateTime(startDate, startTime)
      action.endInviteTm=getDateTime(endDate, endTime)

      try
      {
        let xxx = await dispatch(allowRequest(action)).unwrap();

        if (xxx.resultCode!=0)
        {
            setStatus('error')
            setErrorMessage(xxx.errorMessage)
        }
        else{
            setStatus('idle')
            navigate(-1)
        }
        //
      }
      catch (ex)
      {
          setStatus('error')
          setErrorMessage('Approval error')
      }


  }

  
  useEffect(()=>{
    setErrorMessage('')
    setErrorTitle('')

    let tt = 'Walk-in '
    if (it.type==='Courier') tt+='Courier'
    else  tt+='Visitor'         
    tt+=' Request'
    setAppTitle(['Request', 'Approve', ''+tt])
    setSubTtitle("Approve "+tt)
   
    //setEndDateTime(new Date(Date.now()+30*1000*60))

    return ()=>{
      setOp('')
      setErrorMessage('')
      setErrorTitle('')          
    }
  },[id, dispatch])

  

  
   
  return (
    <Box sx={{p:1}}>
      {/** 
      <Box sx={{ border:0, m:0,p:{xs:0,md:0}, display:'flex',  }}>
                  <Typography variant='h6' sx={{display:{xs:'none', md:'block'}}}>
          {subtitle}
        </Typography>
      </Box>
      */}
      <Box sx={{ display: {xs:'block',md:'flex'}, py: 0, my:0, px:2,bgcolor: 'background.paper', }}  >

          <Grid  container  columns={12}  spacing={2} sx={{mt:1}}> 
              <Grid item xs={12} sm={6}  lg={4} >
                  <FormControl size='small' required  fullWidth >
                    <InputLabel id="id_floor_label" >Floor to Visit</InputLabel>
                        <Select
                            
                            required
                            labelId="id_floor_label"
                            error={Boolean(floorError)}
                            id="id_flooe"
                            value={floor}
                            label="Floor to Visit"
                            onChange={(e)=>setFloor(e.target.value)}
                            
                            >
                          <MenuItem value={''}></MenuItem>
                          
                          {
                              allFloors.map( (ct)=>
                                (<MenuItem key={ct.id} value={ct.name}>{ct.name}</MenuItem>)
                              )
                          }
                          
                      </Select>
                        <FormHelperText error={Boolean(floorError) }>
                          {Boolean(floorError) ? floorError:'Floor to visit'}
                        </FormHelperText>
                                
                    </FormControl>
              
                </Grid>
          
                  {/* <Grid item xs={12} sm={6}  lg={4} > */}
              <Grid container item  xs={12} sm={6}  lg={4}   sx={{px:2}} spacing={0}>
              
                <Grid item xs={6}   sx={{px:1}} >

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                                value={startDate}
                                disablePast
                                size='small'
                                
                                inputFormat="dd/MM/yyyy"
                                onChange={(newValue) => {  setStartDate(newValue);}}
                                renderInput={(props) => 
                                        <TextField {...props} 
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                                  error={Boolean(startDateError)}
                                                  required
                                                  fullWidth
                                        helperText={ startDateError?startDateError:'DD/MM/YYYY' } 
                                              label="Start date"
                                              
                            
                                        />}
                                        />
                      </LocalizationProvider>
                </Grid>
                <Grid item xs={6}  sx={{px:1}}>
                <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      disableClearable
                      //selectOnFocus
                      handleHomeEndKeys
                      //disableClearable
                      id="id_start_timr" 
                      value={startTime}
                options={allStartTimes.map((option) => option)} 
                onChange = { (e, newValue)=>{setStartTime(newValue);   } }
                renderInput={(params) => 
                    <TextField {...params} 
                        required
                        
                      //   InputProps={{ endAdornment: (
                      //     <InputAdornment position="end">
                      //       <ArrowDropDownIcon />
                      //     </InputAdornment>
                      //   ),
                      // }}

                      
                        onChange = { e=>{setStartTime(e.target.value);}}
                        error={Boolean(startTimeError)}
                        label="Start Time"  
                        //inputProps={{ maxLength: 60, minLength:5 }}
                        helperText={ Boolean(startTimeError) ? startTimeError : "HH:mm"}
                      />}

                /> 
                  {/*<FormControl required  fullWidth size="small">
                     <InputLabel id="id_start_time_label" size='sm'>Start Time</InputLabel>
                        <Select size='small'
                            required
                            labelId="id_tart_time_label"
                            error={Boolean(startTimeError)}
                            id="id_tart_time"
                            value={startTime}
                            label={"Start Time"}
                            onChange={(e)=>setStartTime(e.target.value)}
                            
                            >
                          <MenuItem value={''}></MenuItem>
                          
                          {
                              allStartTimes.map(x=><MenuItem key={x} value={x}>{x}</MenuItem>)
                          }
                          
                      </Select >
                        <FormHelperText error={Boolean(startTimeError) }>
                          {Boolean(startTimeError) ?startTimeError:'HH:MM'}
                        </FormHelperText>
                                
                    </FormControl> */}
                  
                </Grid>
            </Grid>
            <Grid container item  xs={12} sm={6}  lg={4}   sx={{px:2}} spacing={0}>
              <Grid item xs={6}   sx={{px:1}} >

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker 
                                value={endDate}
                                disablePast
                                size='small'
                                
                                inputFormat="dd/MM/yyyy"
                                onChange={(newValue) => {  setEndDate(newValue);}}
                                renderInput={(props) => 
                                        <TextField {...props} 
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                                  error={Boolean(endDateError)}
                                                  required
                                                  fullWidth
                                        helperText={ endDateError ?  endDateError :'DD/MMYYYY'}
                                              label="End date"
                                              
                                        />}
                                        />
                      </LocalizationProvider>
                </Grid>
                <Grid item xs={6}  sx={{px:1}}>
                  {/* <FormControl required  fullWidth  size="small">
                    <InputLabel id="id_end_time_label" size='sm'>End Time</InputLabel>
                        <Select size='small'
                            required
                            labelId="id_end_time_label"
                            error={Boolean(endTimeError)}
                            id="id_end_time"
                            value={endTime}
                            label={"End Time"}
                            onChange={(e)=>setEndTime(e.target.value)}
                            
                            >
                          <MenuItem value={''}></MenuItem>
                          
                          {
                              allEndTimes.map(x=><MenuItem key={x} value={x}>{x}</MenuItem>)
                          }
                          
                      </Select >
                        <FormHelperText error={Boolean(endTimeError) }>
                          {Boolean(endTimeError) ?endTimeError:'HH:MM'}
                        </FormHelperText>
                                
                    </FormControl> */}

                    <Autocomplete 
                      fullWidth
                      size='small'
                      freeSolo
                      disableClearable
                      //selectOnFocus
                      handleHomeEndKeys
                      //disableClearable
                      id="id_end_timr" 
                      //popupIcon={<ArrowDropDownIcon />}
                value={endTime}
                options={allEndTimes.map((option) => option)} 
                onChange = { (e, newValue)=>{setEndTime(newValue);   } }
                renderInput={(params) => 
                    <TextField {...params} 
                        required
                        
                      //   InputProps={{ endAdornment: (
                      //     <InputAdornment position="end">
                      //       <ArrowDropDownIcon />
                      //     </InputAdornment>
                      //   ),
                      // }}

                      
                        onChange = { e=>{setEndTime(e.target.value);}}
                        error={Boolean(endTimeError)}
                        label="End Time"  
                        //inputProps={{ maxLength: 60, minLength:5 }}
                        helperText={ Boolean(endTimeError) ? endTimeError : "HH:mm"}
                      />}

                /> 
                  </Grid>
                    
                  
                {/* </Grid> */}
            </Grid>

              
            
          
              
              <Grid item xs={12} >
                <TextField 
                    size='small'
                fullWidth
                value={hostRemarks}
                id="id_remarks" label="Remarks" type="text" 
                onChange = { e=>setHostRemarks(e.target.value)}
                inputProps={{ maxLength: 100,  }}
                helperText={ "Remarks (optional)"}/>

              </Grid>

          </Grid>
          
</Box>
        
<Box sx={{mt:1,p:1,display:'flex', width:'100%', justifyContent: 'space-around', }}>

            <Button variant="outlined" 
              //variant="contained" 
              color='success'  
              //disabled = {status==='success'}
              onClick ={ doApproveRequest }
            > Approve</Button>

            
            <Button variant="outlined" 
              //variant="contained" 
              color='success'
              //disabled = {status==='success'}
              onClick ={ (e)=>{navigate(-1);} }
            > Cancel</Button>

        </Box>
      
      </Box>
    );
};

export default PendingRequestApprovePage;
